import type { ReactElement } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function About(): ReactElement {
  return (
    <Container className="py-4">
      <Row>
        <Col>
          <h1>About</h1>
          <h2>Overview</h2>
          <p>Project description and background go here.</p>
          <h2>Methodology</h2>
          <p>{"Welch's t-test vs student's, \<...\>?"}</p>
          {<h2>Info</h2>}
          <h4>Data Sources</h4>
          <ul>
            <li>
              Legislator data is pulled from{' '}
              <a target="_blank" href="https://api.congress.gov/">
                congress.gov's API
              </a>
            </li>
            <li>Metric data is pulled from (insert dropbox sources)</li>
            <li>
              <a href="https://docs.google.com/document/d/1i5sRyvlFkM0B-6R2r43ucM24EDjiiQ63hhzqOhLNZoA/edit?usp=sharing">
                Data Dictionary
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}
